var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.91,162.78C595,62,438.79,4.71,347.39,111.18c-3.6,4.18-7,8.57-10.19,13.11-23.31,33.13-58.3,90.49-101,76.46-29.24-9.6-49.29-36.1-78.21-46.4-38.12-13.59-74.35,14.22-97.68,49.77-27.13,41.32-40.1,89.81-24.67,134.64,28.75,83.5,140.66,102.29,217.25,94.64,56.09-5.61,110.23-36,166.41-37.9,40.42-1.38,79.09,9.8,115.51,23.7,16.88,6.44,33.74,13.54,52,15.31,65.33,6.36,77.8-58.95,79.36-113.88C667.73,266.06,668.18,209.82,644.91,162.78Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.91,162.78C595,62,438.79,4.71,347.39,111.18c-3.6,4.18-7,8.57-10.19,13.11-23.31,33.13-58.3,90.49-101,76.46-29.24-9.6-49.29-36.1-78.21-46.4-38.12-13.59-74.35,14.22-97.68,49.77-27.13,41.32-40.1,89.81-24.67,134.64,28.75,83.5,140.66,102.29,217.25,94.64,56.09-5.61,110.23-36,166.41-37.9,40.42-1.38,79.09,9.8,115.51,23.7,16.88,6.44,33.74,13.54,52,15.31,65.33,6.36,77.8-58.95,79.36-113.88C667.73,266.06,668.18,209.82,644.91,162.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.09,
    y: 217.3,
    width: 53.28,
    height: 3.03,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.79,
    y: 263.63,
    width: 63.43,
    height: 3.03,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.19,
    y: 142.42,
    width: 31.08,
    height: 74.48,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,120h3.58a13.75,13.75,0,0,1,13.75,13.75v8.79a0,0,0,0,1,0,0H350.19a0,0,0,0,1,0,0v-8.79A13.75,13.75,0,0,1,363.94,120Z",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,120h1.82a7,7,0,0,1,7,7v15.57a0,0,0,0,1,0,0H357.86a0,0,0,0,1,0,0V127A7,7,0,0,1,364.82,120Z",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.19,
    y: 160.18,
    width: 31.08,
    height: 3.23,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.09,
    y: 210.03,
    width: 53.28,
    height: 7.06,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.06,
    y: 220.32,
    width: 49.34,
    height: 43.39,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.06,
    y: 266.75,
    width: 49.34,
    height: 162.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 226.78,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 226.78,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 226.78,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 247.37,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 269.37,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 247.37,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 269.37,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 247.37,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 269.37,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 285.72,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 285.72,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 285.72,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 302.07,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 302.07,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 302.07,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 318.42,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 318.42,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 318.42,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 334.76,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 334.76,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 334.76,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 351.11,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 351.11,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 351.11,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 367.46,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 367.46,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 367.46,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 383.81,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 383.81,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 383.81,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.96,
    y: 400.16,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 400.16,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.64,
    y: 400.16,
    width: 5.25,
    height: 7.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.04,
    y: 246.16,
    width: 7.02,
    height: 17.56,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.81,
    y: 248.98,
    width: 3.48,
    height: 14.73,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.92,
    y: 248.98,
    width: 3.48,
    height: 14.73,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.4 238.34 332.86 246.21 341.95 246.21 337.4 238.34",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.89,
    y: 207.39,
    width: 4.66,
    height: 9.51,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.12 194.49 338.11 207.41 344.13 207.41 341.12 194.49",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 207.39,
    width: 4.66,
    height: 9.51,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.23 194.49 350.21 207.41 356.24 207.41 353.23 194.49",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.11,
    y: 207.39,
    width: 4.66,
    height: 9.51,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.34 194.49 362.32 207.41 368.35 207.41 365.34 194.49",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.22,
    y: 207.39,
    width: 4.66,
    height: 9.51,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.45 194.49 374.44 207.41 380.46 207.41 377.45 194.49",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.33,
    y: 207.39,
    width: 4.66,
    height: 9.51,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.56 194.49 386.55 207.41 392.57 207.41 389.56 194.49",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.15,
    y: 246.16,
    width: 7.02,
    height: 17.56,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.51 238.34 388.97 246.21 398.06 246.21 393.51 238.34",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.26,
    y1: 142.4,
    x2: 358.26,
    y2: 160.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.09,
    y1: 142.4,
    x2: 361.09,
    y2: 160.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.26,
    y1: 163.39,
    x2: 358.26,
    y2: 216.89,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.09,
    y1: 163.39,
    x2: 361.09,
    y2: 216.89,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.37,
    y1: 142.4,
    x2: 370.37,
    y2: 160.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.2,
    y1: 142.4,
    x2: 373.2,
    y2: 160.27,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.37,
    y1: 163.39,
    x2: 370.37,
    y2: 216.89,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.2,
    y1: 163.39,
    x2: 373.2,
    y2: 216.89,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.4,
    y: 112.34,
    width: 6.36,
    height: 7.87,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.21,104.67h.73a2.81,2.81,0,0,1,2.81,2.81v3.24a0,0,0,0,1,0,0H362.4a0,0,0,0,1,0,0v-3.24A2.81,2.81,0,0,1,365.21,104.67Z",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.4,
    y: 110.89,
    width: 6.36,
    height: 1.47,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.58,
    y1: 104.67,
    x2: 365.58,
    y2: 89.79,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.43,
    y1: 96.15,
    x2: 370.67,
    y2: 96.15,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.91,96a1.36,1.36,0,1,0-1.36,1.36A1.37,1.37,0,0,0,366.91,96Z",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.06,
    y1: 256.96,
    x2: 389.95,
    y2: 256.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "241.58 389.88 241.58 325.3 249.63 325.3 249.63 220.3 256.68 220.3 256.68 133.33 261.21 133.31 261.21 111.17 272.79 111.17 272.79 102.94 277.25 102.94 280.57 102.94 288.94 102.94 288.94 111.17 300.77 111.17 300.77 133.31 305.41 133.33 305.41 220.3 312.61 220.3 312.61 325.3 320.85 325.3 320.85 374.11",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.78,
    y1: 111.17,
    x2: 272.78,
    y2: 219.38,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.94,
    y1: 111.17,
    x2: 288.94,
    y2: 218.52,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.69,
    y1: 219.38,
    x2: 301.55,
    y2: 219.38,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.36,
    y1: 326.07,
    x2: 308.43,
    y2: 326.07,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 227.99,
    x2: 297.24,
    y2: 227.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 235.73,
    x2: 297.24,
    y2: 235.73,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 243.48,
    x2: 297.24,
    y2: 243.48,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 251.22,
    x2: 297.24,
    y2: 251.22,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 258.96,
    x2: 297.24,
    y2: 258.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 266.71,
    x2: 297.24,
    y2: 266.71,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 274.45,
    x2: 297.24,
    y2: 274.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 282.19,
    x2: 297.24,
    y2: 282.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 289.94,
    x2: 297.24,
    y2: 289.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 297.68,
    x2: 297.24,
    y2: 297.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 305.43,
    x2: 297.24,
    y2: 305.43,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 313.17,
    x2: 297.24,
    y2: 313.17,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 320.91,
    x2: 297.24,
    y2: 320.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 332.96,
    x2: 297.24,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 340.7,
    x2: 297.24,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 348.45,
    x2: 297.24,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 356.19,
    x2: 297.24,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 363.93,
    x2: 297.24,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 371.68,
    x2: 297.24,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 379.42,
    x2: 292.08,
    y2: 379.42,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 387.16,
    x2: 292.08,
    y2: 387.16,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 394.91,
    x2: 292.08,
    y2: 394.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 402.65,
    x2: 292.08,
    y2: 402.65,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.27,
    y1: 410.4,
    x2: 292.08,
    y2: 410.4,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 227.99,
    x2: 255.93,
    y2: 227.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 235.73,
    x2: 255.93,
    y2: 235.73,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 243.48,
    x2: 255.93,
    y2: 243.48,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 251.22,
    x2: 255.93,
    y2: 251.22,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 258.96,
    x2: 255.93,
    y2: 258.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 266.71,
    x2: 255.93,
    y2: 266.71,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 274.45,
    x2: 255.93,
    y2: 274.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 282.19,
    x2: 255.93,
    y2: 282.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 289.94,
    x2: 255.93,
    y2: 289.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 297.68,
    x2: 255.93,
    y2: 297.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 305.43,
    x2: 255.93,
    y2: 305.43,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 313.17,
    x2: 255.93,
    y2: 313.17,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 320.91,
    x2: 255.93,
    y2: 320.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 227.99,
    x2: 301.95,
    y2: 227.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 235.73,
    x2: 301.95,
    y2: 235.73,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 243.48,
    x2: 301.95,
    y2: 243.48,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 251.22,
    x2: 301.95,
    y2: 251.22,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 258.96,
    x2: 301.95,
    y2: 258.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 266.71,
    x2: 301.95,
    y2: 266.71,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 274.45,
    x2: 301.95,
    y2: 274.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 282.19,
    x2: 301.95,
    y2: 282.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 289.94,
    x2: 301.95,
    y2: 289.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 297.68,
    x2: 301.95,
    y2: 297.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 305.43,
    x2: 301.95,
    y2: 305.43,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 313.17,
    x2: 301.95,
    y2: 313.17,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 320.91,
    x2: 301.95,
    y2: 320.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 332.96,
    x2: 255.93,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 340.7,
    x2: 255.93,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 348.45,
    x2: 255.93,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 356.19,
    x2: 255.93,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 363.93,
    x2: 255.93,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 371.68,
    x2: 255.93,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 379.42,
    x2: 255.93,
    y2: 379.42,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 387.16,
    x2: 255.93,
    y2: 387.16,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 394.91,
    x2: 255.93,
    y2: 394.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 402.65,
    x2: 255.93,
    y2: 402.65,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.55,
    y1: 410.4,
    x2: 255.93,
    y2: 410.4,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.52,
    y1: 332.96,
    x2: 243.9,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.52,
    y1: 340.7,
    x2: 243.9,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.52,
    y1: 348.45,
    x2: 243.9,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.52,
    y1: 356.19,
    x2: 243.9,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.52,
    y1: 363.93,
    x2: 243.9,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.52,
    y1: 371.68,
    x2: 243.9,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.52,
    y1: 379.42,
    x2: 243.9,
    y2: 379.42,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.52,
    y1: 387.16,
    x2: 243.9,
    y2: 387.16,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 332.96,
    x2: 301.95,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 340.7,
    x2: 301.95,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 348.45,
    x2: 301.95,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 356.19,
    x2: 301.95,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 363.93,
    x2: 301.95,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.57,
    y1: 371.68,
    x2: 301.95,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.89,
    y1: 332.96,
    x2: 312.27,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.89,
    y1: 340.7,
    x2: 312.27,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.89,
    y1: 348.45,
    x2: 312.27,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.89,
    y1: 356.19,
    x2: 312.27,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.89,
    y1: 363.93,
    x2: 312.27,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.89,
    y1: 371.68,
    x2: 312.27,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 147.11,
    x2: 269.71,
    y2: 147.11,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 153.99,
    x2: 269.71,
    y2: 153.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 160.88,
    x2: 269.71,
    y2: 160.88,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 167.76,
    x2: 269.71,
    y2: 167.76,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 174.64,
    x2: 269.71,
    y2: 174.64,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 181.53,
    x2: 269.71,
    y2: 181.53,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 188.41,
    x2: 269.71,
    y2: 188.41,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 195.29,
    x2: 269.71,
    y2: 195.29,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 202.18,
    x2: 269.71,
    y2: 202.18,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 209.06,
    x2: 269.71,
    y2: 209.06,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.25,
    y1: 215.94,
    x2: 269.71,
    y2: 215.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 147.11,
    x2: 299.83,
    y2: 147.11,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 153.99,
    x2: 299.83,
    y2: 153.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 160.88,
    x2: 299.83,
    y2: 160.88,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 167.76,
    x2: 299.83,
    y2: 167.76,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 174.64,
    x2: 299.83,
    y2: 174.64,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 181.53,
    x2: 299.83,
    y2: 181.53,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 188.41,
    x2: 299.83,
    y2: 188.41,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 195.29,
    x2: 299.83,
    y2: 195.29,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 202.18,
    x2: 299.83,
    y2: 202.18,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 209.06,
    x2: 299.83,
    y2: 209.06,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.36,
    y1: 215.94,
    x2: 299.83,
    y2: 215.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "128.6 428.24 128.6 325.3 139.92 325.3 139.92 220.3 149.82 220.3 149.82 133.33 156.18 133.31 156.18 111.17 172.44 111.17 172.44 102.94 178.72 102.94 183.38 102.94 195.13 102.94 195.13 111.17 211.77 111.17 211.77 133.31 218.28 133.33 218.28 220.3 228.4 220.3 228.4 325.3 239.97 325.3 239.97 389.88",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.44,
    y1: 111.17,
    x2: 172.44,
    y2: 219.38,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.13,
    y1: 111.17,
    x2: 195.13,
    y2: 218.52,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.66,
    y1: 219.38,
    x2: 212.85,
    y2: 219.38,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.16,
    y1: 326.07,
    x2: 222.52,
    y2: 326.07,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 227.99,
    x2: 206.81,
    y2: 227.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 235.73,
    x2: 206.81,
    y2: 235.73,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 243.48,
    x2: 206.81,
    y2: 243.48,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 251.22,
    x2: 206.81,
    y2: 251.22,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 258.96,
    x2: 206.81,
    y2: 258.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 266.71,
    x2: 206.81,
    y2: 266.71,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 274.45,
    x2: 206.81,
    y2: 274.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 282.19,
    x2: 206.81,
    y2: 282.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 289.94,
    x2: 206.81,
    y2: 289.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 297.68,
    x2: 206.81,
    y2: 297.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 305.43,
    x2: 206.81,
    y2: 305.43,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 313.17,
    x2: 206.81,
    y2: 313.17,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 320.91,
    x2: 206.81,
    y2: 320.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 332.96,
    x2: 206.81,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 340.7,
    x2: 206.81,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 348.45,
    x2: 206.81,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 356.19,
    x2: 206.81,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 363.93,
    x2: 206.81,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 371.68,
    x2: 206.81,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 379.42,
    x2: 206.81,
    y2: 379.42,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.29,
    y1: 387.16,
    x2: 206.81,
    y2: 387.16,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 227.99,
    x2: 148.76,
    y2: 227.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 235.73,
    x2: 148.76,
    y2: 235.73,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 243.48,
    x2: 148.76,
    y2: 243.48,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 251.22,
    x2: 148.76,
    y2: 251.22,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 258.96,
    x2: 148.76,
    y2: 258.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 266.71,
    x2: 148.76,
    y2: 266.71,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 274.45,
    x2: 148.76,
    y2: 274.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 282.19,
    x2: 148.76,
    y2: 282.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 289.94,
    x2: 148.76,
    y2: 289.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 297.68,
    x2: 148.76,
    y2: 297.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 305.43,
    x2: 148.76,
    y2: 305.43,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 313.17,
    x2: 148.76,
    y2: 313.17,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 320.91,
    x2: 148.76,
    y2: 320.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 227.99,
    x2: 213.42,
    y2: 227.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 235.73,
    x2: 213.42,
    y2: 235.73,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 243.48,
    x2: 213.42,
    y2: 243.48,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 251.22,
    x2: 213.42,
    y2: 251.22,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 258.96,
    x2: 213.42,
    y2: 258.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 266.71,
    x2: 213.42,
    y2: 266.71,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 274.45,
    x2: 213.42,
    y2: 274.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 282.19,
    x2: 213.42,
    y2: 282.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 289.94,
    x2: 213.42,
    y2: 289.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 297.68,
    x2: 213.42,
    y2: 297.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 305.43,
    x2: 213.42,
    y2: 305.43,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 313.17,
    x2: 213.42,
    y2: 313.17,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 320.91,
    x2: 213.42,
    y2: 320.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 332.96,
    x2: 148.76,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 340.7,
    x2: 148.76,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 348.45,
    x2: 148.76,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 356.19,
    x2: 148.76,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 363.93,
    x2: 148.76,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 371.68,
    x2: 148.76,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 379.42,
    x2: 148.76,
    y2: 379.42,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 387.16,
    x2: 148.76,
    y2: 387.16,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 394.91,
    x2: 148.76,
    y2: 394.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 402.65,
    x2: 148.76,
    y2: 402.65,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 410.4,
    x2: 148.76,
    y2: 410.4,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 418.14,
    x2: 148.76,
    y2: 418.14,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.66,
    y1: 425.88,
    x2: 148.76,
    y2: 425.88,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 332.96,
    x2: 131.86,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 340.7,
    x2: 131.86,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 348.45,
    x2: 131.86,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 356.19,
    x2: 131.86,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 363.93,
    x2: 131.86,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 371.68,
    x2: 131.86,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 379.42,
    x2: 131.86,
    y2: 379.42,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 387.16,
    x2: 131.86,
    y2: 387.16,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 394.91,
    x2: 131.86,
    y2: 394.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 402.65,
    x2: 131.86,
    y2: 402.65,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 410.4,
    x2: 131.86,
    y2: 410.4,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 418.14,
    x2: 131.86,
    y2: 418.14,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.76,
    y1: 425.88,
    x2: 131.86,
    y2: 425.88,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 332.96,
    x2: 213.42,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 340.7,
    x2: 213.42,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 348.45,
    x2: 213.42,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 356.19,
    x2: 213.42,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 363.93,
    x2: 213.42,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 371.68,
    x2: 213.42,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 379.42,
    x2: 213.42,
    y2: 379.42,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.31,
    y1: 387.16,
    x2: 213.42,
    y2: 387.16,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.82,
    y1: 332.96,
    x2: 227.92,
    y2: 332.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.82,
    y1: 340.7,
    x2: 227.92,
    y2: 340.7,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.82,
    y1: 348.45,
    x2: 227.92,
    y2: 348.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.82,
    y1: 356.19,
    x2: 227.92,
    y2: 356.19,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.82,
    y1: 363.93,
    x2: 227.92,
    y2: 363.93,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.82,
    y1: 371.68,
    x2: 227.92,
    y2: 371.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.82,
    y1: 379.42,
    x2: 227.92,
    y2: 379.42,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.82,
    y1: 387.16,
    x2: 227.92,
    y2: 387.16,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 147.11,
    x2: 168.13,
    y2: 147.11,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 153.99,
    x2: 168.13,
    y2: 153.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 160.88,
    x2: 168.13,
    y2: 160.88,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 167.76,
    x2: 168.13,
    y2: 167.76,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 174.64,
    x2: 168.13,
    y2: 174.64,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 181.53,
    x2: 168.13,
    y2: 181.53,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 188.41,
    x2: 168.13,
    y2: 188.41,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 195.29,
    x2: 168.13,
    y2: 195.29,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 202.18,
    x2: 168.13,
    y2: 202.18,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 209.06,
    x2: 168.13,
    y2: 209.06,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.83,
    y1: 215.94,
    x2: 168.13,
    y2: 215.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 147.11,
    x2: 210.43,
    y2: 147.11,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 153.99,
    x2: 210.43,
    y2: 153.99,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 160.88,
    x2: 210.43,
    y2: 160.88,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 167.76,
    x2: 210.43,
    y2: 167.76,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 174.64,
    x2: 210.43,
    y2: 174.64,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 181.53,
    x2: 210.43,
    y2: 181.53,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 188.41,
    x2: 210.43,
    y2: 188.41,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 195.29,
    x2: 210.43,
    y2: 195.29,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 202.18,
    x2: 210.43,
    y2: 202.18,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 209.06,
    x2: 210.43,
    y2: 209.06,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.14,
    y1: 215.94,
    x2: 210.43,
    y2: 215.94,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.18,
    y1: 133.31,
    x2: 170.76,
    y2: 133.31,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.77,
    y1: 133.31,
    x2: 195.72,
    y2: 133.31,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 119.58,
    x2: 194,
    y2: 119.58,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "527.83 385.97 527.83 251.22 401.35 251.22 401.35 366.06",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.81,
    y: 220.24,
    width: 43.02,
    height: 30.11,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.35,
    y: 220.24,
    width: 43.02,
    height: 30.11,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.35,
    y: 220.24,
    width: 21.51,
    height: 30.11,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.39,
    y: 238.31,
    width: 37.86,
    height: 12.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.39,
    y: 222.83,
    width: 9.46,
    height: 9.46,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.3,
    y: 222.83,
    width: 12.05,
    height: 9.46,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.79,
    y: 222.83,
    width: 9.46,
    height: 9.46,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.44,256.38V366.5",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.77,256.38V366.5",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.3,256.38V386.86",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.63,256.38V386.86",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.16,256.38V386.86",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.49,256.38V386.86",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 257.24,
    x2: 412.94,
    y2: 257.24,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 264.01,
    x2: 412.94,
    y2: 264.01,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 270.78,
    x2: 412.94,
    y2: 270.78,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 277.54,
    x2: 412.94,
    y2: 277.54,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 284.31,
    x2: 412.94,
    y2: 284.31,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 291.08,
    x2: 412.94,
    y2: 291.08,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 297.84,
    x2: 412.94,
    y2: 297.84,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 304.61,
    x2: 412.94,
    y2: 304.61,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 311.38,
    x2: 412.94,
    y2: 311.38,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 318.15,
    x2: 412.94,
    y2: 318.15,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 324.91,
    x2: 412.94,
    y2: 324.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 331.68,
    x2: 412.94,
    y2: 331.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 338.45,
    x2: 412.94,
    y2: 338.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 342.96,
    x2: 412.94,
    y2: 342.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 349.72,
    x2: 412.94,
    y2: 349.72,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 356.49,
    x2: 412.94,
    y2: 356.49,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 363.26,
    x2: 412.94,
    y2: 363.26,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 257.24,
    x2: 446.5,
    y2: 257.24,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 264.01,
    x2: 446.5,
    y2: 264.01,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 270.78,
    x2: 446.5,
    y2: 270.78,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 277.54,
    x2: 446.5,
    y2: 277.54,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 284.31,
    x2: 446.5,
    y2: 284.31,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 291.08,
    x2: 446.5,
    y2: 291.08,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 297.84,
    x2: 446.5,
    y2: 297.84,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 304.61,
    x2: 446.5,
    y2: 304.61,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 311.38,
    x2: 446.5,
    y2: 311.38,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 318.15,
    x2: 446.5,
    y2: 318.15,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 324.91,
    x2: 446.5,
    y2: 324.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 331.68,
    x2: 446.5,
    y2: 331.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 338.45,
    x2: 446.5,
    y2: 338.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 342.96,
    x2: 446.5,
    y2: 342.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 349.72,
    x2: 446.5,
    y2: 349.72,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 356.49,
    x2: 446.5,
    y2: 356.49,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.12,
    y1: 363.26,
    x2: 446.5,
    y2: 363.26,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 257.24,
    x2: 484.36,
    y2: 257.24,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 264.01,
    x2: 484.36,
    y2: 264.01,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 270.78,
    x2: 484.36,
    y2: 270.78,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 277.54,
    x2: 484.36,
    y2: 277.54,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 284.31,
    x2: 484.36,
    y2: 284.31,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 291.08,
    x2: 484.36,
    y2: 291.08,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 297.84,
    x2: 484.36,
    y2: 297.84,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 304.61,
    x2: 484.36,
    y2: 304.61,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 311.38,
    x2: 484.36,
    y2: 311.38,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 318.15,
    x2: 484.36,
    y2: 318.15,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 324.91,
    x2: 484.36,
    y2: 324.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 331.68,
    x2: 484.36,
    y2: 331.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 338.45,
    x2: 484.36,
    y2: 338.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 342.96,
    x2: 484.36,
    y2: 342.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 349.72,
    x2: 484.36,
    y2: 349.72,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 356.49,
    x2: 484.36,
    y2: 356.49,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 363.26,
    x2: 484.36,
    y2: 363.26,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 370.03,
    x2: 484.36,
    y2: 370.03,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 376.79,
    x2: 484.36,
    y2: 376.79,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.98,
    y1: 383.56,
    x2: 484.36,
    y2: 383.56,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 257.24,
    x2: 514.47,
    y2: 257.24,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 264.01,
    x2: 514.47,
    y2: 264.01,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 270.78,
    x2: 514.47,
    y2: 270.78,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 277.54,
    x2: 514.47,
    y2: 277.54,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 284.31,
    x2: 514.47,
    y2: 284.31,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 291.08,
    x2: 514.47,
    y2: 291.08,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 297.84,
    x2: 514.47,
    y2: 297.84,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 304.61,
    x2: 514.47,
    y2: 304.61,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 311.38,
    x2: 514.47,
    y2: 311.38,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 318.15,
    x2: 514.47,
    y2: 318.15,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 324.91,
    x2: 514.47,
    y2: 324.91,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 331.68,
    x2: 514.47,
    y2: 331.68,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 338.45,
    x2: 514.47,
    y2: 338.45,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 342.96,
    x2: 514.47,
    y2: 342.96,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 349.72,
    x2: 514.47,
    y2: 349.72,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 356.49,
    x2: 514.47,
    y2: 356.49,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 363.26,
    x2: 514.47,
    y2: 363.26,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 370.03,
    x2: 514.47,
    y2: 370.03,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 376.79,
    x2: 514.47,
    y2: 376.79,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.09,
    y1: 383.56,
    x2: 514.47,
    y2: 383.56,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.79 273.59 107.95 273.59 107.95 367.37 91.61 367.37 91.61 277.89 31.38 277.89",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.39 157.44 125.16 157.44 131.19 170.34 113.12 170.34 118.28 176.36",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 176.78 113.18 176.78 117.99 182.72",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 182.72 113.18 182.72 117.99 188.67",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 188.67 113.18 188.67 117.99 194.61",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 194.61 113.18 194.61 117.99 200.55",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 200.55 113.18 200.55 117.99 206.49",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 206.49 113.18 206.49 117.99 212.43",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 212.43 113.18 212.43 117.99 218.38",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 218.38 113.18 218.38 117.99 224.32",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.74 224.32 113.18 224.32 117.99 230.26",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.74 230.26 113.18 230.26 117.99 236.2",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.74 236.2 113.18 236.2 117.99 242.14",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.74 242.14 113.18 242.14 117.99 248.08",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.98 248.08 113.18 248.08 117.99 254.03",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.98 254.03 113.18 254.03 117.99 259.97",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "140.21 259.97 113.18 259.97 117.99 265.91",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.98 265.91 113.18 265.91 117.99 271.85",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "341.99 374.26 292.94 374.26 292.94 416.42 252.5 416.42 252.5 390.61 160.44 390.61 160.44 431.05",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "390.17 366.51 459 366.51 459 386.3 546.76 386.3 546.76 400.07 565.69 400.07 565.69 429.32",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.83,
    y1: 336.4,
    x2: 575.16,
    y2: 336.4,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.24,
    y1: 375.12,
    x2: 458.14,
    y2: 375.12,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.22,
    y: 378.56,
    width: 8.18,
    height: 6.02,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.32,
    y: 378.56,
    width: 8.18,
    height: 6.02,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.42,
    y: 378.56,
    width: 8.18,
    height: 6.02,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.52,
    y: 378.56,
    width: 8.18,
    height: 6.02,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.24,
    y1: 394.62,
    x2: 458.14,
    y2: 394.62,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.22,
    y: 398.06,
    width: 8.18,
    height: 6.02,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.32,
    y: 398.06,
    width: 8.18,
    height: 6.02,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.42,
    y: 398.06,
    width: 8.18,
    height: 6.02,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.52,
    y: 398.06,
    width: 8.18,
    height: 6.02,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.03,
    y1: 412.98,
    x2: 538.16,
    y2: 412.98,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 463.3,
    y1: 427.6,
    x2: 463.3,
    y2: 413.84,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.3,
    y: 378.9,
    width: 42.03,
    height: 6.18,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.3,
    y: 393.11,
    width: 42.03,
    height: 6.18,
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Airplane--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.84,82.25,521.25,69.76l-47.17-9.23a14,14,0,0,0-1.71-.23c-2.51-.19-9.46-.53-13.27,1.21-4.72,2.15-7,5.49-5.66,7.62s10.05,6.86,17.91,9.51,46.79,11.06,52.31,11.5,12.3.73,12.3.73,23.29,2.12,32.18,1.32,21.83-4.81,22.47-6.53S585.84,82.25,585.84,82.25Z",
    style: {
      fill: "#fff",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.21,78s7,.56,10.18-1.2,15.45-19.71,16.23-19.9a59,59,0,0,1,6.28.26l-8.43,26.57-25.29-5.56Z",
    style: {
      fill: "#fff",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.64,90.25s1.82-.61,2.86-1,3.38-1.24,4.69-1.9a4.65,4.65,0,0,0,1.92-1.86L620.17,82l-3.26-.26L582.42,84C582.39,87.52,578.64,90.25,578.64,90.25Z",
    style: {
      fill: "#a1a1a1",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.71,70.52l-20.45,1.71.68-.25-62.45,3.83-39.23,2.4s-4.78-.13-3.15,1.51l6.42,1.78s-12.09-.22-29.88-4.92-23.76-5.69-28.81-8.86a7.92,7.92,0,0,1-3-3.41h0c-1.7,1.69-2.28,3.49-1.44,4.82,1.25,2,8.89,6.22,16.28,8.93l-.34-.09-11-1.38s-2.72-3.75-2.78-3S454,78,455,78.08s13,1.3,13,1.3l-.28,3.52a1.38,1.38,0,1,0,1.34,1.77,1.47,1.47,0,0,0,.52.13,1,1,0,0,0,.17,0,5.35,5.35,0,0,0,4.49,4.91c3.46.79,13.45,2.09,16.6.58,2.28-1.1,1.32-4.71.62-6.61,4.22.95,8.63,1.92,12.8,2.8L504,89.33l2.7,1,2,3.69-1.67.58a1.91,1.91,0,0,0-1.66-1.6,2.15,2.15,0,0,0-.34,4.26,1.87,1.87,0,0,0,1.67-.88l2.55.2,0,.13a2.13,2.13,0,0,0-1.45,1.91,2,2,0,0,0,1.71,2.28,2,2,0,0,0,2-1.86l.19,0a1.82,1.82,0,0,0,1.5,1.1,2.15,2.15,0,0,0,.34-4.26,1.94,1.94,0,0,0-1.91,1.36l-.95-.32-.22-3.55L509,90.23l.42-2.67c6.85,1.4,12.38,2.43,14.22,2.58,5.51.44,12.3.73,12.3.73s2.43.22,6,.49l-.18,2.25h-1.86a1.85,1.85,0,0,0-1.57-1.28,2.15,2.15,0,0,0-.34,4.26,1.89,1.89,0,0,0,1.76-1l1.83.3,0,.07a2.23,2.23,0,0,0-1.06,1.74,2,2,0,0,0,1.71,2.29,1.89,1.89,0,0,0,1.81-1.12l1.47.12a1.87,1.87,0,0,0,1.51,1.13,2.16,2.16,0,1,0-1.71-2.28l-1,.17.15-6.43c7.58.54,18.26,1.12,23.65.64,1.56-.14,3.25-.38,5-.69h0a144,144,0,0,1-15.94-1c-7.48-1.1-7.65-2.12-7.65-2.12s1.26.1,1.34-.91l.2-2.5s3.41,1.53,4.39,1.86S554.09,85,554.09,85l10.2-1.46,3.35,2.29,1.28-.15-1.62-1.9,9.75-1.44.33,0,3.54,1.51,1.5.12-1.24-1.63-.36-1.09,9-1.48s3.35,2.28,5.14,1.92-.11-1.77-.11-1.77l3.56-.35,2.79-.16.2-2.5,3.87-1.42,33.41-4.17,3.85-4ZM474.24,80.38s-3.56-.49-4.36,1.93h-.09a1.67,1.67,0,0,0-.5,0l.22-2.75L480,81l1,.24Z",
    style: {
      fill: "#a1a1a1",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.21,79.09l-8.33.09s.92,1.08,1.18,4.13,2,3.94,4.44,4.39,6.12-.77,6.11-3.8S545.73,79,543.21,79.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.21 62.45 457.25 64.46 459.13 64.64 460.2 62.61 458.21 62.45",
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.59 65.36 468.11 65.51 467.29 63.17 466.66 63.12 466.59 65.36",
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.27 62.85 462.8 65 465.97 65.3 466.04 63.08 463.27 62.85",
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.64 62.8 460.88 62.66 459.79 64.7 462.18 64.94 462.64 62.8",
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.55,62.4l-.13,0A13.16,13.16,0,0,0,455,64.24l1.64.16Z",
    style: {
      fill: "#a1a1a1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.1,71.65s3.8-11.92-10.3-17.89S88.94,56.47,90,62.44,102,74.36,94.36,74.91,81.89,64.06,66.17,69.48,68.88,82,65.09,82,51,79.24,41.77,82s0,7.59,34.7,10.3S103,87.92,116,86.83s11.39,4.88,39,0S173,65.15,136.1,71.65Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.45,157.19s3.71-11.65-10.06-17.47-36,2.65-34.94,8.47,11.64,11.65,4.23,12.18-12.18-10.59-27.53-5.3,2.65,12.18-1.06,12.18-13.77-2.65-22.77,0,0,7.41,33.89,10.06,25.94-4.23,38.65-5.29S568,176.78,595,172,612.46,150.84,576.45,157.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.46,128s1.29-4.06-3.51-6.1-12.57.93-12.2,3,4.07,4.06,1.48,4.25-4.25-3.7-9.61-1.85.93,4.25-.36,4.25-4.81-.92-8,0,0,2.59,11.83,3.51,9.05-1.48,13.48-1.85,3.88,1.67,13.3,0S623,125.75,610.46,128Z",
    style: {
      opacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--road-sign--inject-42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 141.64,
    width: 13.6,
    height: 303.96,
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.66,192.1a2.52,2.52,0,0,1-1.66-.62,2.23,2.23,0,0,1-.11-3.27l44-44.82a2.59,2.59,0,0,1,3.55,0l43.06,43.88a2.23,2.23,0,0,1-.11,3.27,2.5,2.5,0,0,1-3.43-.11l-41.29-42.07-42.21,43A2.5,2.5,0,0,1,213.66,192.1Z",
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,192.1a2.54,2.54,0,0,1-1.66-.62,2.23,2.23,0,0,1-.11-3.27l44-44.82a2.57,2.57,0,0,1,3.54,0L392,187.27a2.24,2.24,0,0,1-.12,3.27,2.5,2.5,0,0,1-3.43-.11l-41.29-42.07-42.2,43A2.52,2.52,0,0,1,303.17,192.1Z",
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.11,
    y: 141.64,
    width: 185.48,
    height: 4.86,
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.11,
    y: 188.26,
    width: 185.48,
    height: 4.86,
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.56,
    y: 119.31,
    width: 163.15,
    height: 97.11,
    style: {
      fill: "#1F2937",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.41,
    y: 125.14,
    width: 153.44,
    height: 85.46,
    rx: 5.5,
    style: {
      fill: "#1F2937",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.34,182.51V197.7h-1V182.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,197.7h-.91V182.51h1.3l4.56,12.83V182.51h.91V197.7h-1.11L100,184.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,197.7V183.42h-3.1v-.91h7.19v.91h-3.09V197.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58,197.7V182.51h1v14.28h4.77v.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.83,195.79v1.91h-1v-1.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.39,194.34l-.76,3.36h-.91L132,182.48h1.45l3.39,15.22h-1l-.76-3.36Zm.15-.87H135l-2.24-9.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,182.51V197.7h-1V182.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3,182.51c2.33,0,3.26,1.28,3.26,3.43v1.32c0,1.78-.69,2.8-2.19,3.15,1.56.35,2.19,1.45,2.19,3.1v2.37a3.36,3.36,0,0,0,.37,1.82h-1a3.55,3.55,0,0,1-.33-1.82v-2.39c0-2-1.11-2.58-2.84-2.58h-1.59v6.79h-1V182.51Zm-.56,7.49c1.78,0,2.82-.5,2.82-2.54V186c0-1.62-.63-2.6-2.28-2.6h-2.15V190Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66,182.51c2.35,0,3.26,1.47,3.26,3.69v1.65c0,2.41-1.11,3.6-3.52,3.6h-1.89v6.25h-1V182.51Zm-.26,8c1.76,0,2.52-.78,2.52-2.63v-1.78c0-1.65-.56-2.71-2.26-2.71h-2.15v7.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,186.22c0-2.22,1-3.84,3.32-3.84s3.36,1.62,3.36,3.84V194c0,2.21-1,3.84-3.36,3.84s-3.32-1.63-3.32-3.84Zm1,7.84c0,1.65.66,2.86,2.33,2.86s2.36-1.21,2.36-2.86v-7.91c0-1.65-.67-2.86-2.36-2.86s-2.33,1.21-2.33,2.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,182.51c2.33,0,3.26,1.28,3.26,3.43v1.32c0,1.78-.7,2.8-2.19,3.15,1.56.35,2.19,1.45,2.19,3.1v2.37a3.36,3.36,0,0,0,.37,1.82h-1a3.55,3.55,0,0,1-.33-1.82v-2.39c0-2-1.11-2.58-2.84-2.58h-1.59v6.79h-1V182.51Zm-.56,7.49c1.78,0,2.82-.5,2.82-2.54V186c0-1.62-.63-2.6-2.28-2.6h-2.15V190Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.74,197.7V183.42h-3.1v-.91h7.18v.91h-3.08V197.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,160.65h-1.35l-4.32-18.11v18.14h-1.2V140.2h1.93l4.3,18.11,4.27-18.11h1.93v20.48h-1.29v-18.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35,140.2v20.48H129V140.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,156.14l-1,4.54H132.4l4.47-20.51h2l4.57,20.51h-1.35l-1-4.54Zm.21-1.17h6l-3-13.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.32,160.65H151l-4.33-18.11v18.14h-1.2V140.2h1.93l4.3,18.11,4.27-18.11h1.93v20.48h-1.28v-18.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.56,140.2v20.48h-1.35V140.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,148.15c0,1.22,0,2.34,0,3.45a7.73,7.73,0,0,1-.11,2.94c-.37.79-1.4,1.28-2.14,1.9-.08.07-.18.11-.23.19a.79.79,0,0,0-.17.39c0,.68,0,1.36,0,2.1,1.28-.38,2.45-.76,3.65-1.07a2.48,2.48,0,0,1,1.21,0c1.19.29,2.37.66,3.57,1,.28-2,.22-2.2-1.26-3.39-.35-.28-.71-.55-1-.85a.81.81,0,0,1-.3-.47c0-2,0-4.06,0-6.2l12,3.7c0-.81,0-1.5,0-2.19a1,1,0,0,0-.59-1.06c-3.59-2.12-7.15-4.27-10.74-6.39A1.14,1.14,0,0,1,88.1,141c0-2.68,0-5.36,0-8a1.62,1.62,0,0,0-.93-1.63A1.58,1.58,0,0,0,85,133c0,2.7,0,5.41,0,8.12a1,1,0,0,1-.59,1c-3.64,2.14-7.25,4.31-10.86,6.47-.21.13-.52.35-.53.54-.06.87,0,1.75,0,2.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,148.15l-12,3.74c0-1,0-1.85,0-2.72,0-.19.32-.41.53-.54,3.61-2.16,7.22-4.33,10.86-6.47a1,1,0,0,0,.59-1c0-2.71,0-5.42,0-8.12a1.58,1.58,0,0,1,2.23-1.63,1.62,1.62,0,0,1,.93,1.63c0,2.69,0,5.37,0,8a1.14,1.14,0,0,0,.67,1.16c3.59,2.12,7.15,4.27,10.74,6.39a1,1,0,0,1,.59,1.06c0,.69,0,1.38,0,2.19l-12-3.7c0,2.14,0,4.17,0,6.2a.81.81,0,0,0,.3.47c.33.3.69.57,1,.85C91,156.85,91,157,90.73,159.05c-1.2-.34-2.38-.71-3.57-1a2.48,2.48,0,0,0-1.21,0c-1.2.31-2.37.69-3.65,1.07,0-.74,0-1.42,0-2.1a.79.79,0,0,1,.17-.39c0-.08.15-.12.23-.19.74-.62,1.77-1.11,2.14-1.9A7.73,7.73,0,0,0,85,151.6C85,150.49,85,149.37,85,148.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.19 201.1 209.77 203.84 207.03 186.26 202.72 190.56 198.4 186.24 192.16 192.47 196.49 196.8 192.19 201.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.2,398.88h-8.31l-.11.17a15.33,15.33,0,0,0-2.15-.17c-10.12,0-18.33,10.56-18.33,23.58S518.51,446,528.63,446c.73,0,6.74-.07,7.44-.17l-5.18.17h8.31c10.12,0,18.32-10.56,18.32-23.58S549.32,398.88,539.2,398.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.15,398.88h-8.3l-.12.17a15.33,15.33,0,0,0-2.15-.17c-10.12,0-18.33,10.56-18.33,23.58S348.46,446,358.58,446a15.33,15.33,0,0,0,2.15-.17l.12.17h8.3c10.12,0,18.33-10.56,18.33-23.58S379.27,398.88,369.15,398.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.2,399.57h-4l-3.56-25a6.19,6.19,0,0,0-6.13-5.31H582.2l-36.26-38.47a20.74,20.74,0,0,0-15.12-6.53H434.71A15.39,15.39,0,0,0,423.62,329L258.54,398.66v29.43H506l62.12-.45,46.05-3v-.21H618a1.5,1.5,0,0,0,1.51-1.51v-22A1.32,1.32,0,0,0,618.2,399.57Z",
    style: {
      fill: "#1F2937",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.89,423.56v4.23l20.27-.15,46.05-3v-.21H618a1.48,1.48,0,0,0,1.34-.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.16,427.64h0a1.51,1.51,0,0,0-.1-3H544.77L458.63,324.24H434.71A15.39,15.39,0,0,0,423.62,329L258.54,398.66v29.43H506Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.11,398.88H288.8l-5.44,8a28.82,28.82,0,0,0,0,31.18l5.44,8h8.31c10.12,0,18.32-10.56,18.32-23.58S307.23,398.88,297.11,398.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.54,
    cy: 422.46,
    rx: 18.33,
    ry: 23.58,
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.54,
    cy: 422.46,
    rx: 14.62,
    ry: 18.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.63,422.46c0,2.2-1.39,4-3.09,4s-3.09-1.77-3.09-4,1.38-4,3.09-4S289.63,420.27,289.63,422.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.08,398.88h-8.3l-5.44,8a28.77,28.77,0,0,0,0,31.18l5.44,8h8.3c10.12,0,18.33-10.56,18.33-23.58S492.2,398.88,482.08,398.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.52,
    cy: 422.46,
    rx: 18.33,
    ry: 23.58,
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.52,
    cy: 422.46,
    rx: 14.62,
    ry: 18.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.6,422.46c0,2.2-1.38,4-3.08,4s-3.09-1.77-3.09-4,1.38-4,3.09-4S474.6,420.27,474.6,422.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.94,330.77c-.3-.32-.62-.61-.94-.91H470.13v37H580Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.54,399.57h-4.36l-4.33-30.33H518.16L481.9,330.77a20.74,20.74,0,0,0-15.11-6.53H378.56A15.37,15.37,0,0,0,367.47,329l-56.36,37.67L259,389.14l-8.15,11a15.58,15.58,0,0,0-3.1,9.33v18.66h16.45v-6.22c0-15.21,11.05-27.53,24.69-27.53h0c12.16,0,19.71,9.85,21.6,23.23L312,428.09H449.36v-6.22c0-15.21,6.24-27.53,23-27.53h0c14.94,0,20.28,9.85,22.61,23.23l1.76,10.07,53.44-3v-.21h4.36Z",
    style: {
      fill: "#1F2937",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.94,334.52l-48.39,32.12H410V330.3H378A14,14,0,0,0,367.94,334.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.43,366.64l28.68-36.34H378a14,14,0,0,0-10,4.22L351,345.76l-16.48,20.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.98 366.64 409.98 340.54 389.39 366.64 409.98 366.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.89,336.22l20.57,21a5.67,5.67,0,0,1,1.41,2.53h0a5.52,5.52,0,0,1-5.36,6.86H416V330.3h48.78A19.67,19.67,0,0,1,478.89,336.22Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.62 330.3 451.63 330.3 422.95 366.64 430.94 366.64 459.62 330.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.04 332.87 416.04 361.89 440.97 330.3 418.07 330.3 416.04 332.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.85,369.24h58.67a6.19,6.19,0,0,1,6.13,5.31l3.56,25h-64Z",
    style: {
      fill: "#1F2937",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.72,
    y: 382.92,
    width: 27.83,
    height: 11.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 617.27,
    y1: 404.25,
    x2: 498.04,
    y2: 404.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.76,
    y1: 404.25,
    x2: 312.62,
    y2: 404.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.75,
    y1: 404.25,
    x2: 253.63,
    y2: 404.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.91,383.1H542.62a6.54,6.54,0,0,0-5.85,3.62l-4.4,8.8a2.64,2.64,0,0,0,2.37,3.82h34.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "568.91 383.1 547.73 383.1 550.04 399.35 568.91 399.35 568.91 383.1",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.77 383.1 605.35 383.1 605.27 399.35 614.08 399.35 611.77 383.1",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.46,
    y: 359.07,
    width: 16.87,
    height: 14.28,
    rx: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.59,
    y: 373.35,
    width: 16.23,
    height: 6.49,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.71,
    y1: 370.75,
    x2: 411.71,
    y2: 420.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,392.82s11.88,6.71,13.4,29.64H441.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.28,402.56s-6.21-16.23-27-16.23c-14.49,0-21.43,7.62-24.9,13.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 549.55,
    y1: 325.62,
    x2: 584.14,
    y2: 325.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 649.01,
    y1: 370.1,
    x2: 653.33,
    y2: 370.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 613.8,
    y1: 370.1,
    x2: 643.45,
    y2: 370.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 662.55,
    y1: 349.22,
    x2: 674.1,
    y2: 349.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.56,
    y1: 349.22,
    x2: 647.71,
    y2: 349.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.3,
    y1: 423.85,
    x2: 638.51,
    y2: 423.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-42"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 38.21,
    y1: 445.86,
    x2: 672.45,
    y2: 445.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.98,
    y1: 445.86,
    x2: 29.85,
    y2: 445.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.fc5f20b4573738ee59dcc111f0f175b2.svg";
export { ForwardRef as ReactComponent };